import "./toaster.css";
let toastContainer = null;

const createContainer = () => {
  toastContainer = document.createElement("div");
  toastContainer.className = "toast-container";
  document.body.appendChild(toastContainer);
};

const showToast = (message, type = "success", duration = 4000) => {
  if (!toastContainer) createContainer();

  const toast = document.createElement("div");
  toast.className = `toast ${type}`;

  toast.innerHTML = `
    <span class="toast-message">${message}</span>
    <button class="toast-close">×</button>
  `;

  toast.querySelector(".toast-close").onclick = () => {
    removeToast(toast);
  };

  setTimeout(() => {
    removeToast(toast);
  }, duration);

  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.classList.add("show");
  }, 10);
};

const removeToast = (toast) => {
  toast.classList.remove("show");
  setTimeout(() => {
    toast.remove();
  }, 300);
};

export const toastSuccess = (msg) => showToast(msg, "success");
export const toastError = (msg) => showToast(msg, "error");
export const toastWarning = (msg) => showToast(msg, "warning");
